import { Controller } from "@hotwired/stimulus"

// Kontroler do sekcji cykliczności w formularzu wydarzenia
export default class extends Controller {
  static targets = ["checkbox", "options", "typeSelect", "weekDays"]

  toggle() {
    if (this.checkboxTarget.checked) {
      this.optionsTarget.classList.remove("hidden")
    } else {
      this.optionsTarget.classList.add("hidden")
    }
  }

  typeChanged() {
    if (this.hasWeekDaysTarget) {
      const type = this.typeSelectTarget.value
      if (type === "weekly" || type === "custom") {
        this.weekDaysTarget.classList.remove("hidden")
      } else {
        this.weekDaysTarget.classList.add("hidden")
      }
    }
  }
}
